module.exports = __webpack_public_path__ + "static/pills-1be8301e8da1fdb86f8967e083434630.png";